import { render, staticRenderFns } from "./LiquidacionesAdministrativo.vue?vue&type=template&id=5dbed381&scoped=true&"
import script from "./LiquidacionesAdministrativo.vue?vue&type=script&lang=js&"
export * from "./LiquidacionesAdministrativo.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionesAdministrativo.vue?vue&type=style&index=0&id=5dbed381&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbed381",
  null
  
)

export default component.exports